import React from 'react';

import classes from './DetailsTable.module.scss';
import { getPriceView } from '../../../../shared/utils/stringUtils';
import {
  CONSULTATION_TYPE,
  ConsultationType,
} from '../../../../shared/constants/coach/consultationType';
import { TaxRateInfo } from '../../../interfaces/tax';
import { CoachInfo } from '../../../interfaces/checkoutInfo';

type DetailsTableProps = {
  //Name of subscription or challenge
  targetName: string;
  totalAmount: number;
  taxAmount: number;
  price: number;
  tax: TaxRateInfo;
  businessName?: string;
  coach?: CoachInfo;
  consultationType?: ConsultationType;
};

const DetailsTable = ({
  targetName,
  businessName,
  coach,
  tax,
  taxAmount,
  price,
  totalAmount,
  consultationType,
}: DetailsTableProps) => {
  return (
    <table className={classes.table}>
      <tbody>
        <tr className={classes.regularRow}>
          <td>
            <p>{targetName}</p>
            {!!coach && (
              <table className={classes.nestedTable}>
                <tbody>
                  <tr>
                    <td>Coach</td>
                    <td>
                      {coach.firstName} {coach.lastName}
                    </td>
                  </tr>
                  {businessName && (
                    <tr>
                      <td>Business Name</td>
                      <td>{businessName}</td>
                    </tr>
                  )}
                  {consultationType === CONSULTATION_TYPE.REMOTE && (
                    <tr>
                      <td>Collaboration</td>
                      <td>To work with a coach remotely</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </td>
          <td align="right">{getPriceView(price)}</td>
        </tr>
        {tax && tax.taxRateType !== 'APPLICATION_TAX_RATE' && (
          <tr className={classes.regularRow}>
            <td>Tax, {tax.taxRatePercent}%</td>
            <td align="right">{getPriceView(taxAmount)}</td>
          </tr>
        )}
        <tr className={classes.totalRow}>
          <td>Total</td>
          <td align="right">{getPriceView(totalAmount)}</td>
        </tr>
      </tbody>
    </table>
  );
};

export { DetailsTable };
